// should match admin-ui app/Enums/ClaimStatus.php
export const CLAIM_STATUS = Object.freeze({
  PENDING: 'pending',
  APPROVED: 'approved',
  DECLINED: 'declined',
  UPDATE_NEEDED: 'update_needed'
})

// mapping of status to translations keys
export const CLAIM_STATUS_TRANSLATION = Object.freeze({
  [CLAIM_STATUS.PENDING]: 'fields.performancerecord_approval_status.options.pending',
  [CLAIM_STATUS.APPROVED]: 'fields.performancerecord_approval_status.options.approved',
  [CLAIM_STATUS.DECLINED]: 'fields.performancerecord_approval_status.options.declined',
  [CLAIM_STATUS.UPDATE_NEEDED]: 'fields.performancerecord_approval_status.options.update_needed'
})



// WEBPACK FOOTER //
// ./src/enums.js